import { render, staticRenderFns } from "./SLItemEditN.vue?vue&type=template&id=c1058412&"
import script from "./SLItemEditN.vue?vue&type=script&lang=js&"
export * from "./SLItemEditN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports